(() => {
  const main = document.getElementById('MainContent');
  if (!main || main.dataset.footerGuidesReady) return;
  main.dataset.footerGuidesReady = 'true';
  main.classList.add('footer-journey-enabled');
  const compact = value => value.replace(/\s+/g, '').replace(/[。:：?？]/g, '');
  const makeToc = (root, sidebar) => {
    const toc = sidebar?.querySelector('[data-guide-toc]');
    if (!toc) return;
    const headings = [...root.querySelectorAll('h2,h3')].filter(h => !h.classList.contains('visually-hidden'));
    const list = toc.querySelector('ol');
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `footer-guide-topic-${index + 1}`;
      heading.setAttribute('tabindex', '-1');
      heading.classList.add('footer-guide__anchor');
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      link.addEventListener('click', () => {
        const details = heading.closest('details');
        if (details) details.open = true;
      });
      item.append(link); list.append(item);
    });
    toc.hidden = headings.length < 2;
    const media = window.matchMedia('(min-width: 990px)');
    const layout = root.closest('.footer-guide__layout');
    const place = () => {
      toc.open = media.matches;
      if (layout) {
        if (media.matches) sidebar.prepend(toc);
        else layout.prepend(toc);
      }
    };
    place(); media.addEventListener('change', place);
  };
  const groupContent = (content, kind) => {
    if (kind === 'policy') {
      [...content.querySelectorAll(':scope > p')].forEach(paragraph => {
        const children = [...paragraph.childNodes];
        const first = children.find(n => n.textContent.trim() || n.nodeName === 'STRONG');
        const headings = children.filter(n => n.nodeName === 'STRONG' && (n === first || /^(第\s*\d+|SECTION\s+\d+|概览|OVERVIEW)/i.test(n.textContent.trim())));
        if (!headings.length) return;
        const output = document.createDocumentFragment();
        let text = document.createElement('p');
        const flush = () => { if (text.textContent.trim()) output.append(text); text = document.createElement('p'); };
        children.forEach(node => {
          if (headings.includes(node)) {
            flush();
            const h2 = document.createElement('h2'); h2.append(...node.childNodes); output.append(h2);
          } else if (!(node.nodeName === 'BR' && !text.textContent.trim())) text.append(node);
        });
        flush(); paragraph.replaceWith(output);
      });
      if (!content.querySelector('h2,h3')) {
        [...content.querySelectorAll(':scope > p')].forEach(paragraph => {
          const nodes = [...paragraph.childNodes];
          const first = nodes.find(n => n.textContent.trim());
          if (!first || first.nodeType !== Node.TEXT_NODE || first.textContent.trim().length > 100 || first.nextSibling?.nodeName !== 'BR') return;
          const h2 = document.createElement('h2'); h2.append(first);
          paragraph.before(h2);
          paragraph.firstChild?.nodeName === 'BR' && paragraph.firstChild.remove();
        });
      }
      [...content.querySelectorAll(':scope > p')].filter(p => !p.textContent.trim() && !p.querySelector('img,video,iframe')).forEach(p => { p.hidden = true; });
    }
    const heading = main.querySelector('h1');
    const first = content.querySelector('h2');
    if (first && heading && (compact(first.textContent).includes(compact(heading.textContent)) || kind === 'medical-disclaimer')) first.classList.add('visually-hidden');
    const nodes = [...content.childNodes];
    const overview = document.createElement('div'); overview.className = 'footer-guide__overview';
    let panel = overview;
    const fragment = document.createDocumentFragment(); fragment.append(overview);
    let question = 0;
    nodes.forEach(node => {
      if (node.nodeType === Node.ELEMENT_NODE && /^H[23]$/.test(node.tagName) && !node.classList.contains('visually-hidden')) {
        if (kind === 'faqs') {
          panel = document.createElement('details'); panel.className = 'footer-guide__question'; panel.open = question++ === 0;
          const summary = document.createElement('summary'); summary.append(node); panel.append(summary);
        } else {
          panel = document.createElement('section'); panel.className = 'footer-guide__panel'; panel.append(node);
        }
        fragment.append(panel);
      } else panel.append(node);
    });
    content.replaceChildren(fragment);
    if (!overview.textContent.trim()) overview.hidden = true;
  };
  main.querySelectorAll('[data-footer-guide]').forEach(guide => {
    const content = guide.querySelector('[data-guide-content]');
    if (!content || content.dataset.enhanced) return;
    content.dataset.enhanced = 'true';
    groupContent(content, guide.dataset.footerGuide);
    makeToc(content, guide.querySelector('.footer-guide__sidebar'));
  });
  const extras = main.querySelector('[data-footer-enhance]');
  if (!extras) return;
  const kind = extras.dataset.footerEnhance;
  main.classList.add('footer-journey-enabled', `footer-journey--${kind}`);
  const sidebar = extras.querySelector('.footer-guide__sidebar');
  if (kind === 'policy') {
    const container = main.querySelector('.shopify-policy__container');
    const body = container?.querySelector('.shopify-policy__body');
    if (!body) return;
    let content = body.querySelector(':scope > .rte') || body;
    while (content.children.length === 1 && content.firstElementChild.tagName === 'DIV') content = content.firstElementChild;
    content.classList.add('footer-guide__article');
    container.classList.add('footer-guide', 'footer-guide--policy');
    const layout = document.createElement('div'); layout.className = 'footer-guide__layout';
    body.before(layout); layout.append(body, sidebar);
    groupContent(content, 'policy'); makeToc(content, sidebar);
  } else if (kind === 'contact') {
    const inner = main.querySelector('.contact-bilingual-page__inner');
    inner?.append(sidebar);
  } else if (kind === 'health-guides') {
    const index = main.querySelector('.starside-editorial-index');
    const filter = extras.querySelector('[data-guide-filter]');
    if (!index || !filter) return;
    const list = index.querySelector('.starside-editorial-index__list');
    const articles = [...list.children];
    list.before(filter); filter.hidden = false;
    const input = filter.querySelector('input');
    const update = () => {
      const query = input.value.trim().toLocaleLowerCase();
      let visible = 0;
      articles.forEach(article => {
        article.hidden = !article.textContent.toLocaleLowerCase().includes(query);
        if (!article.hidden) visible++;
      });
      filter.querySelector('[data-guide-count]').textContent = `${visible} / ${articles.length}`;
      filter.querySelector('[data-guide-empty]').hidden = visible !== 0;
    };
    input.addEventListener('input', update);
    filter.querySelector('button').addEventListener('click', () => { input.value = ''; update(); input.focus(); });
    update(); index.append(sidebar);
  } else {
    const content = main.querySelector(kind === 'about-us' ? '.starside-about' : '.starside-pharmacists');
    if (!content) return;
    makeToc(content, sidebar); content.append(sidebar);
    if (kind === 'about-us') {
      const toc = sidebar.querySelector('[data-guide-toc]');
      const hero = content.querySelector('.starside-about__hero');
      if (toc && hero) { toc.open = true; toc.classList.add('footer-guide__jump-links'); hero.after(toc); }
    }
  }
  if (!extras.children.length) extras.remove();
})();
